//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapActions,
  mapGetters,
} from 'vuex'
import CartProduct from '@app/Cart/Product'
import CartProductUi from '@app/Cart/ProductUi'
import { analyticCheckoutStart } from '@analytic/order.js'

export default {
  name: 'OrderCart',
  props: ['shop', 'chat'],
  components: {
    CartProduct,
    CartProductUi,
  },
  data() {
    return {
      is_product_active: true,
      currency: window.currency,
      user: window.authent,
      // i need backend
      data_modal: [{ icon: 'StarGold', title: 'Середня оцінка магазину', number: '4.8 з 5.0' }, { icon: 'Grade', title: 'Середня оцінка товару', number: '4.9 з 5.0' }, { icon: 'Percent', title: 'Відсоток успішних замовлень', number: '95%' }, { icon: 'Cart', title: 'Скільки працює на Umall', number: '3 роки' }],
      contact: [{ number: '+38 (067) 911-90-90 ' }, { number: '+38 (067) 911-90-90 ' }, { mail: 'Bluetti@gmail.com' }],
      fop: 'ФОП "МАСЛОВ ДАНИЛО ІГОРОВИЧ"',
      fopnumber: '3197921332',
      active_seller: true,
      active_official_label: true,
      work_time: [{ time: 'Пн - Пт з 09:00 до 19:00 ' }, { time: 'Сб - Нд з 10:00 до 15:00' }],
      open_time: 'відчиняється о 09:00',
      close_time: 'зачиняється о 19:00',
    }
  },
  computed: {
    ...mapState('cart', [
      'cart',
    ]),
    ...mapGetters('cart', [
      'getCartByShop',
    ]),
    getShopFromCart() {
      return this.getCartByShop(this.shop)[0].shop
    },
  },
  async mounted() {
    await this.getCart()
    analyticCheckoutStart(this.getCartByShop(this.shop))
  },
  methods: {
    ...mapActions('cart', [
      'getCart',
    ]),
    updateEntities(info) {
      this.$emit('update:cart', info)
    },
  },
}
